import React from 'react';
import { ClipboardList } from 'lucide-react';
import ComingSoonPage from '../components/ComingSoonPage';

export default function WorkOrdersPage() {
  return (
    <ComingSoonPage
      testId="work-orders-page"
      title="Work Orders"
      arabicTitle="أوامر العمل"
      icon={ClipboardList}
      accent="#6FA8FF"
      description="نظام إدارة أوامر العمل الميدانية سيعرض هنا: تعيين المهام للمقاولين، متابعة المراحل، ومؤشرات إنجاز أوامر العمل."
    />
  );
}
